import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useStyles } from './styles';

interface PageProps {
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  children: ReactNode;
  maxWidth?: number;
}

function Page({ title, subtitle, children, maxWidth }: PageProps) {
  const styles = useStyles();

  return (
    <Box className={styles.container} style={{ maxWidth }}>
      <Box className={styles.header}>
        <Typography className={styles.title}>{title}</Typography>
        <Typography className={styles.subtitle}>{subtitle}</Typography>
      </Box>
      {children}
    </Box>
  );
}

export default Page;
